export default __webpack_public_path__ + "static/Rubixcube-6cb60c013ffaaa66a2c235d6fd7e3bc9.png";